module.exports = global["Tether"] = require("-!C:\\Users\\raquel.santamaria\\Documents\\TrabajoGit\\ediprem\\themes\\classic\\_dev\\node_modules\\babel-loader\\index.js!.\\tether.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?Tether!./~/tether/dist/js/tether.js-exposed
// module id = 26
// module chunks = 0